// generic portlet fetch actions - use this in portlet reducer to automatically receive data from fetch actions
export const PORTLET_FETCH_SUCCESS = 'PORTLET_FETCH_SUCCESS';
export const PORTLET_FETCH_FAIL = 'PORTLET_FETCH_FAIL';

export const portletFetchSuccessAction = ({ response, fetchPortlet }) => ({
    type: PORTLET_FETCH_SUCCESS,
    payload: {
        response,
        fetchPortlet
    }
});

export const portletFetchFailAction = ({ error, fetchPortlet }) => ({
    type: PORTLET_FETCH_FAIL,
    payload: {
        error,
        fetchPortlet
    }
});
